import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Cal } from './svg';

const Calendar = (props) => {
    const { selDate, setSelDate } = props;
    // Calculate minimum date (one month ago from today)
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);

    // Maximum date is the current date
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);


    return (
        <>
            <DatePicker
                selected={selDate}
                dateFormat="dd-MMM-yyyy"
                onChange={date => setSelDate(date)}
                minDate={minDate}
                maxDate={maxDate}
            // readOnly={true}
            />
            <div className='cal--icon'><Cal /></div>
            <label className='cal--label'>{props.label}</label>
        </>
    );
};

export default Calendar;
